export const formatNumber = (value: number | string): string => {
  if (typeof value === 'string')
    // eslint-disable-next-line no-param-reassign
    value = parseFloat(value);
  return Intl.NumberFormat('en-GB', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
};
